import { combineReducers } from 'redux';
import rulesEngineReducer from '../rules-engine/rules-engine-reducer';
import bookingFeeDisclaimerReducer from './booking-fee-disclaimer-reducer';
import modalReducer from '../details-modal/modal-reducer';


export const allBookingFeeDisclaimerReducers = {
  rulesEngineReducer,
  bookingFeeDisclaimerReducer,
};

const BookingFeeDisclaimerCombinedReducers = combineReducers({
  modalReducer,
  ...allBookingFeeDisclaimerReducers
});

export default BookingFeeDisclaimerCombinedReducers;
